import axios from "axios";


export const getMapSearchForm = (careersClientId) => {
  const url = `${import.meta.env.VITE_ACTIVATE_BACKEND_API}/api/mapsearchform/${encodeURIComponent(careersClientId)}`;
  return axios.get(url).then((res) => res.data);
};

export const editMapSearchForm = (careersClientId, data) => {
  const url = `${import.meta.env.VITE_ACTIVATE_BACKEND_API}/api/mapsearchform/editmapsearchform/${encodeURIComponent(careersClientId)}`;
  return axios.post(url, data).then((res) => res.data);
};

export const syncMapSearchFormFromProduction = (careersClientId) => {
  const url = `${import.meta.env.VITE_ACTIVATE_BACKEND_API}/api/mapsearchform/syncfromproduction/${encodeURIComponent(careersClientId)}`;
  return axios.post(url).then((res) => res.data);
};
